module.exports = __webpack_public_path__ + "img/Clear_Icon.b1da03aa.svg";